export const ADMIN_SUPABASE_USER_ID = "bf6bcf7d-1860-48a0-8ca0-5dda707e93af";
